import React from 'react';

const DefaultHeaderRenderer = ({ label }) => {
  const children = [
    <span className="textOverflow" key="label" title={typeof label === 'string' ? label : null}>
      {label}
    </span>,
  ];

  return children;
};

export default DefaultHeaderRenderer;
